import { modalRenderer } from '~/modal/modalRendererRegistry';
import { SubscriptionExpiredModal } from './SubscriptionExpiredModal';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    SubscriptionExpired: undefined;
  }
}

modalRenderer.register('SubscriptionExpired', SubscriptionExpiredModal);
